// The constants represent the image (/ animation) to be displayed

export const LIVES_FULL = "LIVES_FULL"
export const LIVES_EMPTY = "LIVES_EMPTY"
export const LIVES_BREAKAGE = "LIVES_BREAKAGE"
